import React from 'react';
import PropTypes, { any } from 'prop-types';

import TextFrame from '../TextFrame';
import { hasPositionLostBySpecialOutcome, hasPositionWon, isMatchInComplete, shouldDisplayWinnerAndScoreData } from '../../../../utils/matchScorePrintPage';

import styles from './matchSheetPlayerData.scss';

const MatchSheetPlayerData = (props) => {
    const {
        match,
        positionType,
        addTopBorder,
    } = props;

    const membersString = positionType === 'positionOne' ? 'positionOneMembers' : 'positionTwoMembers';
    const positionMembers = match[membersString] || [];

    const displayNameOne = positionMembers[0]?.displayName && positionMembers[0]?.displayName !== '' ? positionMembers[0]?.displayName : 'NA';
    const displayNameTwo = positionMembers[1]?.displayName && positionMembers[1]?.displayName !== '' ? positionMembers[1]?.displayName : 'NA';
    const titleNameOne = positionType === 'positionOne' ? 'PL 1 TEAM 1' : 'PL 1 TEAM 2';
    const titleNameTwo = positionType === 'positionOne' ? 'PL 2 TEAM 1' : 'PL 2 TEAM 2';

    const shouldDisplayWinnerScoreData = shouldDisplayWinnerAndScoreData(match);
    const positionWon = hasPositionWon(match, positionType);
    const positionLostBySpecialOutcome = hasPositionLostBySpecialOutcome(match, positionType);
    const isMatchIncomplete = isMatchInComplete(match);

    return (
        <div className={`${styles.matchSheetPlayerData} ${addTopBorder ? styles.addTopBorder : ''}`}>
            <div className={styles.firstHalf}>
                <TextFrame
                    className={`${styles.wrapper} ${styles.playerName}`}
                    title={titleNameOne}
                    description={displayNameOne}
                />
                {shouldDisplayWinnerScoreData && isMatchIncomplete && displayNameOne !== 'NA' && (
                    <div className={`${styles.wrapper} ${styles.incomplete}`}>
                        Incomplete
                    </div>
                )}
                {shouldDisplayWinnerScoreData && positionWon && displayNameOne !== 'NA' && (
                    <div className={`${styles.wrapper} ${styles.winner}`}>
                        W
                    </div>
                )}
                {shouldDisplayWinnerScoreData && positionLostBySpecialOutcome && displayNameOne !== 'NA' && (
                    <div className={`${styles.wrapper} ${styles.specialOutcome}`}>
                        {match.result.outcome}
                    </div>
                )}
            </div>
            <div className={styles.secondHalf}>
                <TextFrame
                    className={`${styles.wrapper} ${styles.playerName}`}
                    title={titleNameTwo}
                    description={displayNameTwo}
                />
                {shouldDisplayWinnerScoreData && isMatchIncomplete && displayNameTwo !== 'NA' && (
                    <div className={`${styles.wrapper} ${styles.incomplete}`}>
                        Incomplete
                    </div>
                )}
                {shouldDisplayWinnerScoreData && positionWon && displayNameTwo !== 'NA' && (
                    <div className={`${styles.wrapper} ${styles.winner}`}>
                        W
                    </div>
                )}
                {shouldDisplayWinnerScoreData && positionLostBySpecialOutcome && displayNameTwo !== 'NA' && (
                    <div className={`${styles.wrapper} ${styles.specialOutcome}`}>
                        {match.result.outcome}
                    </div>
                )}
            </div>
        </div>
    );
};

MatchSheetPlayerData.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
    positionType: PropTypes.oneOf(['positionOne', 'positionTwo']).isRequired,
    addTopBorder: PropTypes.bool,
};

MatchSheetPlayerData.defaultProps = {
    addTopBorder: false,
};

export default MatchSheetPlayerData;
